import { render } from "./CircleCircleNoneIcon.vue?vue&type=template&id=f4f7939a"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__